import React from "react";
import Draggable from "react-draggable";
import {
  MapContainer,
  TileLayer,
  Marker,
  Polyline,
  Polygon,
} from "react-leaflet";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import ClearIcon from "@mui/icons-material/Clear";
import Typography from "@mui/material/Typography";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert from "@mui/material/Alert";
import DrawTools from "./DrawTools";
import Loading from "./Loading";
import "./drop-file-input.css";
import { handleSessionExpired, esSesionVencida } from "../api";

const toLeaflet = (c) => [c[1], c[0]]; // [lng,lat] -> [lat,lng]
const toLeafletLine = (coords) => coords.map(toLeaflet);
const toLeafletPoly = (rings) => rings.map(toLeafletLine);

var data = {};
var geometria = {};
const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const getCookie = (name) => {
  var nameEQ = name + "=";
  var ca = document.cookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == " ") c = c.substring(1, c.length);
    if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
  }
  return null;
};
function PaperComponent(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper
        {...props}
        style={{
          // Alto y ancho fijos (no "auto"): con auto el modal se redimensionaba
          // cada vez que el selector de Tipo de Instalacion mostraba u ocultaba
          // el campo "Detalle de la instalacion". El scroll va en el
          // DialogContent, asi el contenedor nunca cambia de tamano.
          height: "min(88vh, 860px)",
          width: "min(92vw, 880px)",
          maxWidth: "none",
          margin: 0,
          display: "flex",
          flexDirection: "column",
        }}
      />
    </Draggable>
  );
}
function PaperComponentCoor(props) {
  return (
    <Draggable
      handle="#draggable-dialog-title"
      cancel={'[class*="MuiDialogContent-root"]'}
    >
      <Paper
        {...props}
        style={{
          minHeight: "440px",
          height: "auto",
          width: "640px",
          maxWidth: "800px",
        }}
      />
    </Draggable>
  );
}
const getDetails = async (id) => {
  try {
    let solicitudes = await fetch(
      process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_GET_DETAIL,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${getCookie("asa_hd_auth")}`,
        },
        body: JSON.stringify({
          id: id,
        }),
      }
    );
    if (solicitudes.ok) {
      const _solicitudes = await solicitudes.json();
      return _solicitudes;
    } else {
      return [];
    }
  } catch (error) {
    return [];
  }
};
export default function DraggableDialog(props) {
  const [geometry, setGeometry] = React.useState(false);
  const [geometryCoord, setGeometryCoord] = React.useState(false);
  const [openCoord, setOpenCoord] = React.useState(false);
  const [other, setOther] = React.useState("none");
  const [kml, setKml] = React.useState(null);
  const [error, setOpenError] = React.useState(false);
  const [errorText, setOpenErrorText] = React.useState(false);
  const [loading, setLoading] = React.useState(false);
  const [latText, setLatText] = React.useState("");
  const [lngText, setLngText] = React.useState("");
  const [editDataMarker, setEditDataMarker] = React.useState(data);
  const [editDataPolyline, setEditDataPolyline] = React.useState(data);
  const [editDataPolygon, setEditDataPolygon] = React.useState(data);
  const [kmlMarker, setKmlMarker] = React.useState(data);
  const [kmlPolyline, setKmlPolyline] = React.useState(data);
  const [kmlPolygon, setKmlPolygon] = React.useState(data);

  /* Coordenadas functions */
  const LATITUDE_EXPRESSION =
    /^[\+-]?(([1-9]?\d)\D+([1-9]?\d|60)\D+([1-9]?\d|60)(\.\d+)?|90\D+0\D+0)\D+([a-zA-z])$/; // 40° 26′ 46″ N
  const LONGITUDE_EXPRESSION =
    /^[\+-]?(([1-9]?\d{1,2})\D+([1-9]?\d|60)\D+([1-9]?\d|60)(\.\d+)?|180\D+0\D+0)\D+([EWew])$/; // 79° 58′ 56″ W
  const matchText = (expression, text) => {
    expression.lastIndex = 0;
    return expression.exec(text);
  };
  const parseCordinate = (expression, limit, surfaces, text, textHook) => {
    const match = matchText(expression, text);
    if (match) {
      const degrees = parseInt(match[2]); // 0-90° or 0-180°
      if (degrees > limit) {
        textHook(
          "Valor incorrecto de los grados (tiene que estar en un rango de 0 a " +
            limit +
            ")."
        );
        return;
      }
      const minutes = parseInt(match[3] || "0"); // 0-59′
      if (minutes > 59) {
        textHook(
          "Valor incorrecto de los minutos (tiene que estar en un rango de 0 a 59)."
        );
        return;
      }
      const seconds = parseInt(match[4] || "0"); // 0-59′
      if (seconds > 59) {
        textHook(
          "Valor incorrecto de los segundos (tiene que estar en un rango de 0 a 59)."
        );
        return;
      }
      if (degrees === 0 && minutes === 0) {
        return 0;
      }
      const surface = match[6]; // N/S or E/W
      switch (surface) {
        case surfaces[0]:
          return +(degrees + minutes / 60);
        case surfaces[1]:
          return -(degrees + minutes / 60);
        default:
          textHook(
            "Valor incorrecto de la division (tiene que ser " +
              surfaces[0] +
              " o " +
              surfaces[1] +
              ")."
          );
          return;
      }
    }
    textHook("Formato incorrecto de coordenada.");
  };
  const parseLatitude = (latitude) =>
    parseCordinate(LATITUDE_EXPRESSION, 90, "NS", latitude, setLatText);
  const parseLongitude = (longitude) =>
    parseCordinate(LONGITUDE_EXPRESSION, 180, "EW", longitude, setLngText);

  const handleSubmitCoord = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    if (data.get("Latitud").length != 0 && data.get("Longitud").length != 0) {
      setGeometryCoord(false);
      const lat = parseLatitude(data.get("Latitud")); // 57° 57' 49.9212" S
      const lng = parseLongitude(data.get("Longitud")); // 37° 55' 5.5236" W
      if (lat && lng) {
        setLatText("");
        setLngText("");
        let geojson = {
          type: "Point",
          coordinates: [lng, lat],
        };
        setGeometryCoord([geojson]);
        setOpenCoord(false);
      }
    }
  };
  const handleCloseCoord = (event, reason) => {
    if (reason && reason == "backdropClick") return;
    setOpenCoord(false);
    setLatText("");
    setLngText("");
  };
  const mapConfig = {
    lat: -36.587997,
    lng: -65.285522,
    zoom: 6,
  };
  const handleClose = (event, reason) => {
    if (reason && reason == "backdropClick") return;

    props.setOpenEdit(false);
    setOther("none");
    props.setEditRow(null);
    setKml(null);
  };
  const handleSubmit = async (event) => {
    const state = event.nativeEvent.submitter.id;
    event.preventDefault();
    const data = new FormData(event.currentTarget);
    // El campo "detalle" solo se renderiza cuando el tipo de instalacion es
    // OTRA, asi que data.get() devuelve null si no esta en el form.
    const detalle = data.get("detalle") ?? "";

    let solicitudData = props.editRow
      ? {
          id: props.editRow.solicitud.attributes.id,
          denominacion: data.get("denominacion"),
          tipo_instalacion: data.get("instalacion"),
          tipo_cruce: data.get("cruce"),
          detalle_instalacion: detalle,
          estado: state == "borrador" ? "Borrador" : "Para validar",
          geometry: geometry || geometryCoord,
        }
      : {
          denominacion: data.get("denominacion"),
          tipo_instalacion: data.get("instalacion"),
          tipo_cruce: data.get("cruce"),
          detalle_instalacion: detalle,
          estado: state == "borrador" ? "Borrador" : "Para validar",
          geometry: geometry || geometryCoord,
        };

    if (state == "borrador") {
      setLoading(true);
      save(solicitudData).then((x) => {
        if (x.length != 0) {
          props.setLoading(true);
          props.setOpenEdit(false);
          props.setEditRow(false);
          props.setNuevaSolicitudes(Math.random());
          setLoading(false);
        } else {
          setLoading(false);
        }
      });
    } else if (state == "presentar" && solicitudData.geometry) {
      let confirmPresentar = window.confirm(
        "¿Seguro desea presentar la solicitud? No podra volver a modificar una vez presentado."
      );
      if (confirmPresentar) {
        setLoading(true);
        save(solicitudData).then((x) => {
          if (x.attributes) {
            props.setLoading(true);
            props.setOpenEdit(false);
            setLoading(false);
            props.setEditRow(false);
            props.setNuevaSolicitudes(Math.random());
            if (x.attributes.estado == "Desestimado") {
              alert(
                "Su solicitud ha sido desestimada porque no existe interferencia."
              );
            } else {
              alert(
                "Estamos procesando su solicitud. Por favor, cargue la documentación técnica necesaria."
              );
              //alert("Su solicitud interfiere con la traza, por favor cargar documentación técnica.");
            }
          } else {
            setLoading(false);
          }
        });
      }
    } else {
      window.confirm(
        "Necesita ingresar una geometria para presentar la solicitud"
      );
    }
  };
  const handleCloseError = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenError(false);
  };
  const save = async (solicitudData) => {
    try {
      let solicitudes = await fetch(
        process.env.REACT_APP_API_ROOT + process.env.REACT_APP_API_SAVE,
        {
          method: "POST",
          headers: { "Content-Type": "application/json", "Authorization": `Bearer ${getCookie("asa_hd_auth")}` },
          body: solicitudData.id
            ? JSON.stringify({
                id: solicitudData.id,
                denominacion: solicitudData.denominacion,
                tipo_instalacion: solicitudData.tipo_instalacion,
                tipo_cruce: solicitudData.tipo_cruce,
                detalle_instalacion: solicitudData.detalle_instalacion,
                estado: solicitudData.estado,
                geometries: solicitudData.geometry,
              })
            : JSON.stringify({
                denominacion: solicitudData.denominacion,
                tipo_instalacion: solicitudData.tipo_instalacion,
                tipo_cruce: solicitudData.tipo_cruce,
                detalle_instalacion: solicitudData.detalle_instalacion,
                estado: solicitudData.estado,
                geometries: solicitudData.geometry,
              }),
        }
      );
      if (solicitudes.ok) {
        const _solicitudes = await solicitudes.json();
        return _solicitudes;
      }
      const _solicitudes = await solicitudes.json().catch(() => ({}));
      // Un 403 puede ser token vencido o una validacion de negocio ("Tipo de
      // instalacion no valido", ...). Solo el primero desloguea, y se distingue
      // porque responde { message: "Token ..." } en vez de { error: ... }.
      if (esSesionVencida(solicitudes.status, _solicitudes)) {
        handleSessionExpired();
        return [];
      }
      setOpenError(true);
      setOpenErrorText(_solicitudes.error || _solicitudes.message || "No se pudo guardar la solicitud.");
      return [];
    } catch (error) {
      // Fallo de red: antes se devolvia [] y el usuario no se enteraba de nada.
      setOpenError(true);
      setOpenErrorText("No se pudo conectar con el servidor. Revisá tu conexión.");
      return [];
    }
  };

  React.useEffect(() => {
    setKml(false);
    setGeometry(false);
    setEditDataMarker(data);
    setEditDataPolyline(data);
    setEditDataPolygon(data);
    if (props.editRow) {
      props.setLoading(true);
      getDetails(props.editRow.solicitud.attributes.id).then((x) => {
        const geometries = x?.geometries ?? [];
        // setGeometry guarda lo que se va a re-enviar al guardar, en el orden
        // [lng,lat] de GeoJSON. Antes el bloque de abajo hacia reverse(), que
        // MUTA el array: al ser el mismo objeto que acaba de guardarse en el
        // estado, la geometria quedaba invertida y el borrador se guardaba mal.
        // toLeaflet* convierte a [lat,lng] devolviendo arrays nuevos.
        setGeometry(geometries);
        let geoTypeMarker = { geometries: [] };
        let geoTypePolyline = { geometries: [] };
        let geoTypePolygon = { geometries: [] };
        geometries.forEach((g) => {
          if (g && g.type === "Point") {
            geoTypeMarker.geometries.push({ ...g, coordinates: toLeaflet(g.coordinates) });
          } else if (g && g.type === "LineString") {
            geoTypePolyline.geometries.push({ ...g, coordinates: toLeafletLine(g.coordinates) });
          } else if (g && g.type === "Polygon") {
            geoTypePolygon.geometries.push({ ...g, coordinates: toLeafletPoly(g.coordinates) });
          }
        });
        setEditDataMarker(geoTypeMarker);
        setEditDataPolyline(geoTypePolyline);
        setEditDataPolygon(geoTypePolygon);
        props.setLoading(false);
      }).catch(() => {
        // Sin catch el loading quedaba prendido si fallaba la consulta.
        props.setLoading(false);
      });
    } else {
      props.setLoading(false);
    }
  }, [props.openEdit]);

  React.useEffect(() => {
    setKmlMarker(data);
    setKmlPolyline(data);
    setKmlPolygon(data);

    if (kml) {
      props.setLoading(true);

      let kmlTypeMarker = { geometries: [] };
      let kmlTypePolyline = { geometries: [] };
      let kmlTypePolygon = { geometries: [] };

      kml.forEach((g) => {
        if (!g) return;
        if (g.type === "Point") {
          kmlTypeMarker.geometries.push({
            ...g,
            coordinates: toLeaflet(g.coordinates), // <- sin reverse()
          });
        } else if (g.type === "LineString") {
          kmlTypePolyline.geometries.push({
            ...g,
            coordinates: toLeafletLine(g.coordinates), // <- sin reverse()
          });
        } else if (g.type === "Polygon") {
          kmlTypePolygon.geometries.push({
            ...g,
            coordinates: toLeafletPoly(g.coordinates), // <- sin reverse()
          });
        }
      });

      setKmlMarker(kmlTypeMarker);
      setKmlPolyline(kmlTypePolyline);
      setKmlPolygon(kmlTypePolygon);
      props.setLoading(false);
    } else {
      props.setLoading(false);
    }
  }, [kml]);

  /* React.useEffect(() => {
    setKmlMarker(data);
    setKmlPolyline(data);
    setKmlPolygon(data);
    if (kml) {
      props.setLoading(true);

      let kmlTypeMarker = { geometries: [] };
      let kmlTypePolyline = { geometries: [] };
      let kmlTypePolygon = { geometries: [] };
      kml.forEach((geometries) => {
        if (geometries && geometries.type === "Point") {
          geometries.coordinates = geometries.coordinates.reverse();
          kmlTypeMarker.geometries.push(geometries);
        } else if (geometries && geometries.type === "LineString") {
          geometries.coordinates = geometries.coordinates.map((coord) =>
            coord.reverse()
          );
          kmlTypePolyline.geometries.push(geometries);
        } else if (geometries && geometries.type === "Polygon") {
          geometries.coordinates = geometries.coordinates.map((ring) =>
            ring.map((coord) => coord.reverse())
          );
          kmlTypePolygon.geometries.push(geometries);
        }
      });
      setKmlMarker(kmlTypeMarker);
      setKmlPolyline(kmlTypePolyline);
      setKmlPolygon(kmlTypePolygon);
      props.setLoading(false);
    } else {
      props.setLoading(false);
    }
  }, [kml]); */
  return (
    <div>
      <Dialog
        open={props.openEdit}
        onClose={handleClose}
        // Evita que la pagina de atras se corra al abrir el modal (MUI bloquea
        // el scroll del body y compensa la barra con padding-right).
        disableScrollLock
        PaperComponent={PaperComponent}
        aria-labelledby="draggable-dialog-title"
      >
        <DialogTitle
          style={{ cursor: "move", padding: 0, flex: "none" }}
          id="draggable-dialog-title"
        >
          <div className="ds-modal-head">
            <div>
              <div className="ds-modal-title">
                {props.editRow ? "Editar solicitud" : "Nueva solicitud de interferencia"}
              </div>
              <div className="ds-modal-sub">Completá los datos y dibujá la ubicación de la obra sobre la traza.</div>
            </div>
            <div className="ds-modal-x" onClick={handleClose}>
              <ClearIcon style={{ fontSize: 16 }} />
            </div>
          </div>
        </DialogTitle>
        {loading ? (
          <Loading color={"#00000024"} height={"100%"} width={"100%"} />
        ) : null}
        {/* El form es el que enlaza el alto fijo del Paper con el scroll del
            contenido: sin flex aca, DialogContent no sabe cuanto puede crecer. */}
        <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }}>
          <DialogContent style={{ flex: 1, minHeight: 0, overflowY: "auto" }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} style={{ marginBottom: "10px" }}>
                <TextField
                  required
                  variant="outlined"
                  name="denominacion"
                  fullWidth
                  id="denominacion"
                  label="Nombre de la obra"
                  defaultValue={
                    props.editRow
                      ? props.editRow.solicitud.attributes.denominacion
                      : ""
                  }
                />
              </Grid>
              <Grid item xs={6} sm={6}>
                <FormControl fullWidth required>
                  <InputLabel variant="outlined">
                    Tipo de Instalación{" "}
                  </InputLabel>
                  <Select
                    fullWidth
                    label="Tipo de Instalación"
                    name="instalacion"
                    variant="outlined"
                    defaultValue={
                      props.editRow
                        ? props.editRow.solicitud.attributes.tipo_instalacion
                        : ""
                    }
                    onChange={(e) => {
                      if (e.target.value == "OTRA") {
                        setOther("block");
                      } else {
                        setOther("none");
                      }
                    }}
                  >
                    <MenuItem value={"GOD"}> Gasoducto</MenuItem>
                    <MenuItem value={"RG"}> Red de Gas</MenuItem>
                    <MenuItem value={"OLD"}> Oleoducto</MenuItem>
                    <MenuItem value={"LCC"}>
                      {" "}
                      Línea de conducción de crudo{" "}
                    </MenuItem>
                    <MenuItem value={"RED"}>
                      {" "}
                      Red eléctrica distribución{" "}
                    </MenuItem>
                    <MenuItem value={"LAT"}>Línea de alta tensión</MenuItem>
                    <MenuItem value={"FO"}> Fibra óptica </MenuItem>
                    <MenuItem value={"ACD"}> Acueducto </MenuItem>
                    <MenuItem value={"RDA"}>Red distribución agua </MenuItem>
                    <MenuItem value={"RDC"}>Red de cloacas</MenuItem>
                    <MenuItem value={"OTRA"}> Otra</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={6} sm={6}>
                <FormControl fullWidth>
                  <InputLabel variant="outlined">Tipo de Cruce</InputLabel>
                  <Select
                    required
                    fullWidth
                    label="Tipo de Cruce"
                    name="cruce"
                    variant="outlined"
                    defaultValue={
                      props.editRow
                        ? props.editRow.solicitud.attributes.tipo_cruce
                        : ""
                    }
                  >
                    <MenuItem value={"Aéreo"}> Aéreo</MenuItem>
                    <MenuItem value={"Superficial"}> Superficial</MenuItem>
                    <MenuItem value={"Soterrado"}> Soterrado</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              {other === "block" && (
                <Grid item xs={12} sm={12} style={{ minWidth: 0 }}>
                  <TextField
                    multiline={true}
                    minRows={3}
                    variant="outlined"
                    name="detalle"
                    fullWidth
                    id="detalles"
                    label="Detalle de la instalacion"
                    defaultValue={
                      props.editRow
                        ? props.editRow.solicitud.attributes.detalle_instalacion
                        : ""
                    }
                  />
                </Grid>
              )}
              {/* Envuelto en Grid item: estaba suelto dentro del Grid container,
                  sin las restricciones de ancho de una columna, y descolocaba
                  el layout. */}
              <Grid item xs={12} sm={12} style={{ minWidth: 0 }}>
                <Typography
                  variant="subtitle2"
                  style={{ marginBottom: "10px", fontWeight: 700, color: "var(--ink-2)" }}
                >
                  Dibuje en el mapa donde se ejecutará la obra. (Solo una
                  solicitud por interferencia)
                </Typography>
                <MapContainer
                  center={[mapConfig.lat, mapConfig.lng]}
                  zoom={mapConfig.zoom}
                  style={{
                    width: "100%",
                    height: "360px",
                    marginBottom: "16px",
                    borderRadius: "10px",
                  }}
                >
                  <DrawTools
                    setGeometryCoord={setGeometryCoord}
                    setKml={setKml}
                    setOpenCoord={setOpenCoord}
                    setGeometry={setGeometry}
                    geometry={geometry}
                  />
                  <TileLayer
                    attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                    url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                  />
                  {geometryCoord ? (
                    <Marker
                      color="blue"
                      // toLeaflet en vez de reverse(): reverse() muta el array
                      // en cada render, asi que las coordenadas se invertian
                      // una y otra vez — y geometryCoord es lo que se envia al
                      // guardar la solicitud.
                      position={toLeaflet(geometryCoord[0].coordinates)}
                    />
                  ) : (
                    ""
                  )}

                  {kmlMarker.geometries
                    ? kmlMarker.geometries.map((x) => (
                        <Marker color="blue" position={x.coordinates} />
                      ))
                    : null}
                  {kmlPolyline.geometries
                    ? kmlPolyline.geometries.map((x) => (
                        <Polyline color="blue" positions={x.coordinates} />
                      ))
                    : null}
                  {kmlPolygon.geometries
                    ? kmlPolygon.geometries.map((x) => (
                        <Polygon color="blue" positions={x.coordinates[0]} />
                      ))
                    : null}

                  {editDataMarker.geometries
                    ? editDataMarker.geometries.map((x) => (
                        <Marker color="blue" position={x.coordinates} />
                      ))
                    : null}
                  {editDataPolyline.geometries
                    ? editDataPolyline.geometries.map((x) => (
                        <Polyline color="blue" positions={x.coordinates} />
                      ))
                    : null}
                  {editDataPolygon.geometries
                    ? editDataPolygon.geometries.map((x) => (
                        <Polygon color="blue" positions={x.coordinates[0]} />
                      ))
                    : null}
                </MapContainer>
              </Grid>
            </Grid>
            <Snackbar
              open={error}
              autoHideDuration={6000}
              onClose={handleCloseError}
            >
              <Alert
                onClose={handleCloseError}
                severity="error"
                sx={{ width: "100%" }}
              >
                {errorText}
              </Alert>
            </Snackbar>
          </DialogContent>
          <DialogActions style={{ padding: '16px 22px', background: 'var(--surface-2)', borderTop: '1px solid var(--border)', gap: 10, flex: 'none' }}>
            <Button type="submit" id="borrador" className="ds-btn ds-btn-ghost" style={{ fontFamily: 'var(--font)', fontWeight: 700, textTransform: 'none', borderRadius: 9, border: '1px solid var(--border-strong)', color: 'var(--ink-2)', background: 'var(--surface)' }}>
              Guardar borrador
            </Button>
            <Button type="submit" id="presentar" className="ds-btn ds-btn-primary" style={{ fontFamily: 'var(--font)', fontWeight: 700, textTransform: 'none', borderRadius: 9, background: 'var(--blue-600)', color: '#fff' }}>
              Presentar solicitud →
            </Button>
          </DialogActions>
        </form>
      </Dialog>
      <Dialog
        open={openCoord}
        onClose={handleCloseCoord}
        // Evita que la pagina de atras se corra al abrir el modal (MUI bloquea
        // el scroll del body y compensa la barra con padding-right).
        disableScrollLock
        PaperComponent={PaperComponentCoor}
        aria-labelledby="draggable-dialog-title-Coord"
      >
        <DialogTitle style={{ cursor: "move", padding: 0 }} id="draggable-dialog-title">
          <div className="ds-modal-head">
            <div className="ds-modal-title">Ingreso de coordenadas</div>
            <div className="ds-modal-x" onClick={handleCloseCoord}><ClearIcon style={{ fontSize: 16 }} /></div>
          </div>
        </DialogTitle>
        <form id="coord" onSubmit={handleSubmitCoord}>
          <DialogContent>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} style={{ marginBottom: "20px" }}>
                <FormControl fullWidth>
                  <InputLabel variant="outlined">
                    Coordenadas geográficas
                  </InputLabel>
                  <Select
                    fullWidth
                    defaultValue={1}
                    label="Coordenadas geográficas"
                    name="cruce"
                    variant="outlined"
                  >
                    <MenuItem value={1}> WGS 84</MenuItem>
                    <MenuItem value={2}> POSGAR</MenuItem>
                  </Select>
                </FormControl>
              </Grid>
              <Typography
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "5px",
                }}
              >
                Ingresar coordenadas como indica el ejemplo.
              </Typography>
              <Grid item xs={12} sm={12} style={{ marginBottom: "10px" }}>
                <TextField
                  variant="outlined"
                  name="Latitud"
                  fullWidth
                  id="latitud"
                  label="Latitud"
                  helperText={latText}
                  /* placeholder="Ej. 40° 26′ 46″ N" */
                />
                <Typography
                  style={{
                    marginLeft: "10px",
                    marginTop: "5px",
                    color: "#c4c4c4",
                  }}
                >
                  Ej. 40° 26′ 46″ S
                </Typography>
              </Grid>
              <Grid item xs={12} sm={12} style={{ marginBottom: "10px" }}>
                <TextField
                  variant="outlined"
                  name="Longitud"
                  fullWidth
                  id="longitud"
                  label="Longitud"
                  helperText={lngText}
                  /*  placeholder="Ej. 79° 58′ 56″ W" */
                />
                <Typography
                  style={{
                    marginLeft: "10px",
                    marginTop: "5px",
                    color: "#c4c4c4",
                  }}
                >
                  Ej. 79° 58′ 56″ W
                </Typography>
              </Grid>
            </Grid>
          </DialogContent>
        </form>
        <DialogActions style={{ padding: '14px 22px', background: 'var(--surface-2)', borderTop: '1px solid var(--border)', gap: 10 }}>
          <Button onClick={handleCloseCoord} style={{ fontFamily: 'var(--font)', fontWeight: 700, textTransform: 'none', borderRadius: 9, border: '1px solid var(--border-strong)', color: 'var(--ink-2)', background: 'var(--surface)' }}>
            Cancelar
          </Button>
          <Button type="submit" form="coord" style={{ fontFamily: 'var(--font)', fontWeight: 700, textTransform: 'none', borderRadius: 9, background: 'var(--blue-600)', color: '#fff' }}>
            Colocar marcador
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
